import { canOnlyAccessOwnResource } from "../../utils/auth/accessRules";

/**
 * Decides which row actions a viewer is allowed to take on a partner user.
 * The seven booleans are consumed both by the users table (to hide the
 * three-dot button entirely when nothing applies) and by the actions modal
 * (to render only the buttons that apply). Pure and stateless so both
 * callers get the same answer for the same input.
 */
export const eligibilityFor = (partnerUser, {
  authUser,
  canManageUsers,
  canManageTransactionLimits,
  actions,
}) => {
  const isPendingVerification = partnerUser.status?.toLowerCase() === "pending";
  const isSelf = canOnlyAccessOwnResource(authUser, partnerUser.id);

  const canView = !!actions.onViewInfo;
  const canManageLimits = !!actions.onManageTransactionLimits
    && canManageTransactionLimits
    && partnerUser.has_wallet
    && !isSelf;
  const canEdit = !!actions.onEditUser
    && canManageUsers
    && !isSelf
    && !isPendingVerification;
  const canActivate = !!actions.onActivateWallet
    && canManageUsers
    && (partnerUser.role_slug === "accountant" || partnerUser.role_slug === "user")
    && !partnerUser.has_wallet
    && !isPendingVerification;
  const canAssignTeam = !!actions.onAssignTeam
    && canManageUsers
    && partnerUser.has_wallet
    && !isSelf
    && !isPendingVerification;
  const canChangeRole = !!actions.onChangeRole
    && !isSelf
    && !isPendingVerification;
  const canDelete = !!actions.onDeleteUser
    && canManageUsers
    && !isSelf;
  const canResendVerification = !!actions.onResendVerification
    && canManageUsers
    && isPendingVerification;
  const canFixEmail = !!actions.onFixEmail
    && canManageUsers
    && isPendingVerification;

  const hasAny = canView || canManageLimits || canEdit || canActivate
    || canAssignTeam || canChangeRole || canDelete || canResendVerification || canFixEmail;

  return { canView, canManageLimits, canEdit, canActivate, canAssignTeam, canChangeRole, canDelete, canResendVerification, canFixEmail, hasAny };
};
